import { render, staticRenderFns } from "./From.vue?vue&type=template&id=d5680c2a&scoped=true&"
import script from "./From.vue?vue&type=script&lang=js&"
export * from "./From.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5680c2a",
  null
  
)

export default component.exports